// @flow
import * as React from 'react'
import { type ComponentType } from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  children: React.Node,
}

const SemiBoldText: ComponentType<Props> = tw.span`
  text-base
  text-gray-700
  font-semibold
`

export default SemiBoldText
